import { render, staticRenderFns } from "./ForgotPass.vue?vue&type=template&id=3c619710&scoped=true"
import script from "./ForgotPass.vue?vue&type=script&lang=ts"
export * from "./ForgotPass.vue?vue&type=script&lang=ts"
import style0 from "./ForgotPass.vue?vue&type=style&index=0&id=3c619710&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c619710",
  null
  
)

export default component.exports